import React, { useRef } from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit, faTimes } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import _ from "lodash";
import { getBreakpointFromWidth } from "../helpers";
import * as Yup from "yup";
import useNextFocus from "./useNextFocus";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("Required")
    .email("Invalid Email"),
  phone_number: Yup.string().matches(phoneRegExp, "Phone number is not valid")
});

const getInitialValues = contact =>
  contact
    ? _.pick(contact, ["email", "phone_number"])
    : { email: "", phone_number: "" };

export const ContactForm = props => {
  const {
    currentContact,
    failSubmitContact,
    submittingContact,
    onSubmit,
    onClickClear
  } = props;
  const divRef = useRef(null);
  const breakpoint = getBreakpointFromWidth(
    _.get(divRef, "current.clientWidth")
  );
  const grid = breakpoint === "xs" ? "col-12" : "col px-1";
  const { focusInput, setInputRef, getInputRef } = useNextFocus();
  return (
    <div ref={divRef}>
      <Formik
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        initialValues={getInitialValues(currentContact)}
        render={({ submitForm }) => (
          <Form>
            {failSubmitContact && (
              <Alert color="danger">{failSubmitContact}</Alert>
            )}
            <div className="row align-items-center">
              <div className={grid}>
                <label>Add mom and dad here:</label>
              </div>
              <div className={grid}>
                <Field
                  innerRef={setInputRef("email")}
                  onKeyPress={focusInput("phone_number")}
                  name="email"
                  type="email"
                  component={TextInput}
                  placeholder="Contact's Email"
                />
              </div>
              <div className={grid}>
                <Field
                  innerRef={setInputRef("phone_number")}
                  onKeyPress={ev => {
                    if (ev.key === "Enter") {
                      const ref = getInputRef("phone_number");
                      ref && ref.blur();
                      submitForm();
                    }
                  }}
                  name="phone_number"
                  component={TextInput}
                  placeholder="Contact's Phone Number"
                />
              </div>
            </div>
            <div className="row">
              <div className={grid + " mb-1"}>
                <Button
                  fill
                  block
                  type="button"
                  onClick={submitForm}
                  disabled={submittingContact}
                  color="info"
                >
                  {currentContact ? "Update" : "Create"} Contact{" "}
                  <FontAwesomeIcon icon={currentContact ? faEdit : faPlus} />
                </Button>
              </div>
              {currentContact && (
                <div className={grid + " mb-1"}>
                  <Button
                    type="button"
                    onClick={onClickClear}
                    color="info"
                    block
                  >
                    Clear <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </div>
              )}
            </div>
          </Form>
        )}
      />
    </div>
  );
};

ContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submittingContact: PropTypes.bool.isRequired,
  failSubmitContact: PropTypes.string,
  initialValues: PropTypes.object.isRequired
};

export default ContactForm;
